import { CITIES_ALIASES } from '../constants';

export const getCityAlias = (city: string): string => {
  return CITIES_ALIASES[city] || city;
};
